import React, {useState, useEffect} from 'react';
import Http from "../../../http";
import Transition from "../../../utils/transition";
import {toast} from "react-toastify";
import {TextInput, FieldContainer, TextareaInput, Message, BULMA} from "@graffer-inc/graffer-ui";
import Datetime from 'react-datetime';
import moment from 'moment';
import { ja } from 'moment/locale/ja';

const Main = () => {
  const initialFormData = {
    title: '',
    message: '',
    startAt: new Date(),
    endAt: new Date(),
  };
  const [formData, setFormData] = useState(initialFormData);
  const [isLoading, setIsLoading] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  useEffect(() => {
    const fetchOpsNotification = async () => {
      await Http.fetchOpsNotification(
        res => {
          if (res.data.opsNotification) {
            setFormData({
              title: res.data.opsNotification.title,
              message: res.data.opsNotification.message,
              startAt: new Date(res.data.opsNotification.startAt),
              endAt: new Date(res.data.opsNotification.endAt),
            });
            setIsRegistered(true);
          }
        },
        (err) => {
          if ([401, 403].includes(err.response.status)) {
            Transition.goToEmsLogin();
          } else {
            toast.error('データの取得に失敗しました。画面をリロードまたは再ログインしてください。');
          }
        }
      );
    };
    fetchOpsNotification();
  }, []);
  const upsertOpsNotification = async () => {
    setIsLoading(true);
    await Http.upsertOpsNotification(
      formData,
      (res) => {
        toast.success('設定を登録しました。');
        setFormData({
          title: res.data.opsNotification.title,
          message: res.data.opsNotification.message,
          startAt: new Date(res.data.opsNotification.startAt),
          endAt: new Date(res.data.opsNotification.endAt),
        });
        setIsRegistered(true);
        setIsLoading(false);
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else {
          toast.error('失敗しました。画面をリロードまたは再ログインしてください。');
        }
        setIsLoading(false);
      }
    );
  };
  const deleteOpsNotification = async () => {
    setIsLoading(true);
    await Http.deleteOpsNotification(
      () => {
        toast.success('設定を削除しました。');
        setFormData(initialFormData);
        setIsRegistered(false);
        setIsLoading(false);
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else {
          toast.error('失敗しました。画面をリロードまたは再ログインしてください。');
        }
        setIsLoading(false);
      }
    );
  };
  return (
    <div>
      <p className="is-size-3 has-text-weight-bold">電子証明書取得サポート - メッセージ差込設定</p>
      <br/>
      {
        isRegistered && (
          <Message color={BULMA.COLOR.INFO}>
            <p>下記の内容で設定されています。</p>
          </Message>
        )
      }
      <FieldContainer name="タイトル" required>
        <TextInput
          value={formData.title}
          onChange={v => setFormData(
            (f) => {
              f.title = v;
              return Object.assign({}, f);
            })}
        />
      </FieldContainer>
      <FieldContainer name="メッセージ" required>
        <TextareaInput
          value={formData.message}
          onChange={v => setFormData(
            (f) => {
              f.message = v;
              return Object.assign({}, f);
            })}
        />
      </FieldContainer>
      <FieldContainer name="表示開始時刻" required>
        <Datetime
          locale={ja}
          className="input"
          value={formData.startAt}
          onChange={v => setFormData(
            (f) => {
              f.startAt = moment(v).toDate();
              return Object.assign({}, f);
            })}
         />
      </FieldContainer>
      <FieldContainer name="表示終了時刻" required>
        <Datetime
          locale={ja}
          className="input"
          value={formData.endAt}
          onChange={v => setFormData(
            (f) => {
              f.endAt = moment(v).toDate();
              return Object.assign({}, f);
            })}
        />
      </FieldContainer>
      <br/>
      <div className="columns is-marginless">
        <div className="column is-8 is-paddingless">
          <div className="is-flex">
            <button
              onClick={upsertOpsNotification}
              className={`button is-fullwidth is-info ${isLoading ? 'is-loading' : ''}`}
              disabled={isLoading || (formData.title.length === 0 || formData.message.length === 0)}>
              登録する
            </button>
            <div style={{width: '50px'}}/>
            {isRegistered ? (
              <button
                onClick={deleteOpsNotification}
                className={`button is-fullwidth is-danger is-outlined ${isLoading ? 'is-loading' : ''}`}
                disabled={isLoading}>
                削除する
              </button>
            ) : (
              <div style={{width: '100%'}}/>
            )}
          </div>
        </div>
      </div>
    </div>
  )
};

export default Main;